/**
 * Emit hosts for the `paywall` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import {
  SegmentActionName,
  SegmentObjectName,
  trackLegacyEvent,
} from '@heidi/analytics/events';
import { SubscriptionTier } from '@heidi/schema/ml-scribe';

export function paywallCheckoutClickedFromUpgrade() {
  trackLegacyEvent({
    name: SegmentObjectName.Paywall,
    props: {
      action: SegmentActionName.PaywallCheckoutClickedFromUpgrade,
      target_plan: SubscriptionTier.PRO_PLUS,
      // [4/5] getSegmentContext() removed with the model's state; it was
      // provably always undefined (setSegmentContext had zero dispatchers).
      paywall_context: undefined,
    },
  });
}
